var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    className: "social-link"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-linkedin)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.8571.628H2.1361C.9577.628 0 1.599 0 2.7908V28.465c0 1.1919.9576 2.1629 2.1362 2.1629H27.857c1.1786 0 2.1429-.971 2.1429-2.1629V2.7909c0-1.192-.9643-2.163-2.1429-2.163ZM9.067 26.3421H4.6205V12.0253h4.4532v14.3169H9.067ZM6.8437 10.0699c-1.4263 0-2.578-1.1585-2.578-2.5781 0-1.4197 1.1517-2.5782 2.578-2.5782 1.4197 0 2.5782 1.1585 2.5782 2.5782 0 1.4263-1.1518 2.5781-2.5782 2.5781Zm18.8907 16.2723h-4.4465v-6.9643c0-1.6607-.0334-3.7968-2.3102-3.7968-2.317 0-2.6719 1.808-2.6719 3.6763v7.0848h-4.4464V12.0253h4.2656v1.9553h.0603c.5959-1.125 2.0491-2.3103 4.212-2.3103 4.5 0 5.3371 2.9666 5.3371 6.8237v7.8482Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .628h30v30H0z"
  })))));
};
export default SvgLinkedin;